import { useMutation, useQueryClient } from 'react-query';

import { useFirebase } from 'components/Firebase/index.js';
import { useOrgId } from 'hooks/index.js';
import { vodUrl } from '../../../../../client-config.js';

const useCreateMediaAssetMutation = (options) => {
  const firebase = useFirebase();
  const orgId = useOrgId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ videoId, file, sourceUrl, customData, platform, importData }) => {
      const idToken = await firebase.getIdToken();
      const fetchUrl = new URL(`${vodUrl}/v1/orgs/${orgId}/media-assets`);

      // Get the duration and dimensions of the video and send it to the server.
      // The server will use the duration to determine the most appropriate format to
      // encode the video in. The dimensions are mostly sent as a placeholder that
      // can be rendered until the video is fully processed.
      const { duration, streams } = file?.ffprobeData || {};
      const length = duration && (duration / 1000000); // convert to seconds
      const { width, height } = (streams || []).find((stream) => stream.width > 0) || {};

      try {
        const response = await fetch(`${fetchUrl}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
          },
          mode: 'cors',
          body: JSON.stringify({
            ref: {
              videoId,
            },
            data: {
              data: {
                filename: file.name,
                title: file.name,
                length,
                sourceUrl,
                ...(width > 0 && height > 0 && { width, height }),
              },
              type: 'video',
              customData,
              sourcePlatform: platform,
              importData,
            },
          }),
        });
        if (response.ok) {
          queryClient.invalidateQueries(['videos', orgId, {}]);
          return response.json();
        } else {
          throw new Error(response);
        }
      } catch (e) {
        throw e;
      }
    },
    ...options,
  });
};

export default useCreateMediaAssetMutation;
